import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
import GoogleTranslateWidget from '../../../../components/GoogleTranslateWidget';
export function BlogPostNarcissismGaslightingID() {
  const articleData = {
    title: 'Pelajari Tentang Istilah: Narsisme & Gaslighting',
    description: 'Bingung dengan perilaku narsistik atau gaslighting? Pelajari tanda-tanda utama dalam teks dan lihat bagaimana AI Toxic Detector langsung mengidentifikasi pola manipulasi halus.',
    slug: 'narcissism-gaslighting-explained',
    publishDate: '2025-07-15',
    author: 'Toxic Detector Editorial'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: window.location.href
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Tautan disalin ke clipboard!');
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-7035">
      <GoogleTranslateWidget data-id="element-7036" />
      <Helmet data-id="element-7037">
        <title data-id="element-7038">Narsisme & Gaslighting Dijelaskan | ToxicDetector</title>
        <meta name="description" content="Memahami psikologi di balik strategi manipulasi narsisme dan gaslighting." data-id="element-7039" />
        <meta name="keywords" content="narsisme, gaslighting, manipulasi, psikologi, analisis AI" data-id="element-7040" />
        <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/iLMUMmEFFWiRSqv8DSTAdz/file_00000000f0c8720a9c4e7f9e2fbdea6d.png" data-id="element-7041" />
        <link rel="canonical" href={`https://toxicdetector.com/id/blog/${articleData.slug}`} data-id="element-7042" />
        <script type="application/ld+json" data-id="element-7043">
          {JSON.stringify(articleSchema)}
        </script>
      </Helmet>

      <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-7044">
        <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-7045">
          <div className="flex items-center justify-between" data-id="element-7046">
            <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-7047">
              🚩 ToxicDetector
            </Link>
            <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Share article" data-id="element-7048">
              <Share2 size={20} className="text-gray-600" data-id="element-7049" />
            </button>
          </div>
        </div>
      </header>

      <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-7050">
        <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-7051">
          <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-7052" />
          Kembali ke Blog
        </Link>

        <header className="mb-12" data-id="element-7053">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-7054">
            {articleData.title}
          </h1>
          <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-7055">
            <time dateTime={articleData.publishDate} data-id="element-7056">
              {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </time>
            <span className="text-gray-300" data-id="element-7057">•</span>
            <span data-id="element-7058">{articleData.author}</span>
          </div>
        </header>

        <div className="prose prose-lg max-w-none" data-id="element-7059">
          <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-7060">
            Pernahkah Anda bertanya-tanya mengapa beberapa orang membuat Anda
            merasa bingung, lelah, atau meragukan diri sendiri dalam hubungan?
            Itu sering kali adalah <strong data-id="element-7061">narsisme dan gaslighting</strong>{' '}
            yang sedang bekerja.
          </p>

          <section className="mb-12" data-id="element-7062">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7063">
              Apa itu Narsisme?
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-7064">
              <strong data-id="element-7065">Narsisme</strong> adalah pola perilaku egois dan
              manipulatif di mana seseorang memprioritaskan kebutuhan mereka
              sendiri di atas orang lain.
            </p>
          </section>

          <section className="mb-12" data-id="element-7066">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7067">
              Apa itu Gaslighting?
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-7068">
              <strong data-id="element-7069">Gaslighting</strong> adalah teknik manipulasi psikologis
              yang membuat Anda mempertanyakan realitas, ingatan, atau perasaan
              Anda sendiri.
            </p>
          </section>

          <section className="mb-12" data-id="element-7070">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7071">
              Bagaimana AI Kami Mendeteksi Pola Ini
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-7072">
              Alih-alih menebak, AI kami menganalisis percakapan Anda untuk pola
              manipulasi.
            </p>
          </section>

          <section className="mb-12" data-id="element-7073">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7074">
              Mengapa Memahami Ini Penting
            </h2>
            <p className="text-lg leading-relaxed text-gray-600" data-id="element-7075">
              Mengenali <strong data-id="element-7076">narsisme</strong> atau{' '}
              <strong data-id="element-7077">gaslighting</strong> sejak dini melindungi kesehatan
              emosional Anda.
            </p>
          </section>
        </div>

        <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-7078">
          <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-7079">
            💀 Siap Melihat Kebenaran?
          </h2>
          <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-7080">
            Berhenti menebak. Unggah teks Anda ke Toxic Detector dan dapatkan
            skor toksisitas instan.
          </p>
          <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-7081">
            Pindai Chat Anda Sekarang →
          </Link>
        </div>

        <div className="mt-16" data-id="element-7082">
          <RelatedBlogPosts posts={[{
          title: '7 Tanda Gaslighting',
          description: 'Pelajari pola gaslighting utama yang dideteksi AI dalam percakapan teks Anda.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'Apakah Mantan Anda Narsisis Tersembunyi?',
          description: 'Temukan apakah mantan Anda menunjukkan tanda-tanda perilaku narsistik tersembunyi melalui analisis teks.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }]} data-id="element-7083" />
        </div>
      </article>

      <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-7084">
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-7085">
          <p className="text-gray-500 text-sm" data-id="element-7086">
            © {new Date().getFullYear()} ToxicDetector. Semua hak dilindungi.
          </p>
        </div>
      </footer>
    </div>;
}